import styled from 'styled-components'

export const PageView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TurnstileContainer = styled.div``

export const TextTurnstile = styled.div`
  color: ${(p) => p.theme.color.black};
  font-weight: 600;
  margin-top: 4px;
  padding-bottom: 8px;
  font-size: 14px;

  span {
    font-weight: 400;
    padding: 0px 4px;
  }
`
